import _ from 'lodash'
import api from '../api'
import * as types from '../types'

export default {
  state: {
    contract: {
      show: false,
      content: ''
    }
  },
  getters: {
    [types.GET_CONTRACT]: state => state.contract
  },
  actions: {
    [types.SET_BANK_STATE] ({dispatch, commit}) {
      api.bankCardContract().then((res) => {
        const resData = res.data
        if (Number(resData.code) === 0) {
          commit(types.SET_CONTRACT_STATE, {
            title: '银行卡协议',
            show: true,
            content: resData.bankCardContract
          })
        } else {
          dispatch(types.SET_FAIL_MESSAGE, {
            show: true,
            content: '银行卡协议获取失败'
          })
          return res
        }
      })
    }
  },
  mutations: {
    [types.SET_CONTRACT_STATE] (state, data) {
      // debugger
      state.contract = {
        title: _.isEmpty(data.title) ? state.contract.title : data.title,
        show: data.show,
        content: _.isEmpty(data.content) ? state.contract.content : data.content
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/bank.js